// import { toastError, toastSuccess } from "@/config/ToastModal";
import isEmpty from "../../../lib/isEmpty";
import { schoolProfile } from "../../../validation/companyprofile";
import { useEffect, useState } from "react";
import { GetCountries } from "react-country-state-city/dist/cjs";
import { myProfiles } from "../../../services/auth";
import { toastError, toastSuccess } from "../../../config/ToastModal";

const initialFormValue = {
  comapanyName: "",
  since: "",
  teamSize: "",
  description: "",
  type: "",
  companyLogo: "",
  companyCover: "",
  jobTitle: "",
  country: "",
  typesOfService: "",
  manPowerRequirement: "",
};

const FormInfoBox = ({ proDetail, servicesList }) => {
  const catOptions = [
    { value: "1-8", label: "1-8" },
    { value: "9-12", label: "9-12" },
  ];

  const [logoImg, setLogoImg] = useState(null);
  const [coverImg, setCoverImg] = useState(null);
  const [logoImgPreview, setLogoImgPreview] = useState(null);
  const [coverImgPreview, setCoverImgPreview] = useState(null);
  const [countriesList, setCountriesList] = useState([]);

  // const [formData, setFormData] = useState(initialFormValue);
  const [formData, setFormData] = useState({
    companyName: "", // Corrected key
    since: "",
    teamSize: "",
    description: "",
    type: "",
    companyLogo: "",
    // companyCover: "",
    jobTitle: "",
    // country: "",
    typesOfService: "",
    // manPowerRequirement: "",
  });

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const logoImgString = { companyLogo: "", companyCover: "" };
  const errMessage = {
    ...initialFormValue,
    ...logoImgString,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSelectChange = (selectedOptions) => {
    setFormData((prevData) => ({ ...prevData, classes: selectedOptions }));
  };

  const handleBlur = ({ target: { name } }) => {
    setTouched((prevTouched) => ({ ...prevTouched, [name]: true }));
  };

  const handleSelectBlur = () => {
    setTouched((prevTouched) => ({ ...prevTouched, classes: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDatas = new FormData();
    if (formData.jobTitle) formDatas.append("jobTitle", formData.jobTitle);
    if (formData.companyName)
      formDatas.append("companyName", formData.companyName);
    // if (formData.country) formDatas.append("country", formData.country);
    if (formData.typesOfService)
      formDatas.append("typesOfService", formData.typesOfService);
    // if (formData.manPowerRequirement)
    //   formDatas.append("manPowerRequirement", formData.manPowerRequirement);
    if (formData.teamSize) formDatas.append("teamSize", formData.teamSize);
    if (formData.description)
      formDatas.append("description", formData.description);
    if (formData.since) formDatas.append("since", formData.since);

    // Append the logo and cover images
    if (logoImg) formDatas.append("companyLogo", logoImg);
    // if (coverImg) formDatas.append("companyCover", coverImg);

    if (formData.type) formDatas.append("type", formData.type);

    const { status, message, errors } = await myProfiles(formDatas);

    if (status) {
      toastSuccess(message);
    } else if (message) {
      toastError(message);
    } else if (errors) {
      Object.keys(errors).forEach((item) => {
        toastError(errors[item]);
      });
      setErrors(errors);
    }
  };

  useEffect(() => {
    if (proDetail && servicesList) {
      setFormData({
        companyName: proDetail.companyName || "",
        since: proDetail.since || "",
        teamSize: proDetail.teamSize || "",
        description: proDetail.description || "",
        type: proDetail.type || "",
        jobTitle: servicesList.jobTitle || "",
        // country: proDetail.country || "",
        typesOfService: servicesList.typesOfService || "",
        // manPowerRequirement: proDetail.manPowerRequirement || "",
      });
      setLogoImgPreview(proDetail.companyLogo || "");
      setCoverImgPreview(proDetail.companyCover || "");
    }
  }, [proDetail]);

  useEffect(() => {
    const checkValidation = schoolProfile(formData);
    if (!checkValidation.status) {
      setErrors(checkValidation.errors);
    } else {
      setErrors({});
    }
  }, [formData]);

  const handleLogoChange = (e) => {

    const file = e.target.files[0];
    if (file) {
      setLogoImg(file);
      setLogoImgPreview(URL.createObjectURL(file));
    }
  };

  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCoverImg(file);
      setCoverImgPreview(URL.createObjectURL(file));
    }
  };

  // const CompanyTypes = ["Private Limited", "Single LLP"];
  const CompanyTypes = [
    "Private Limited(Pvt. Ltd.)",
    "Limited Liability Partnership(LLP)",
    "Sole Proprietorship",
    "Public Limited Company",
    "MNC/Corporate Entity",
  ];

  useEffect(() => {
    GetCountries().then((result) => {
      setCountriesList(result);
    });
  }, []);

  const updateProfileImage = async () => {
    const formDatas = new FormData();

    if (logoImg) formDatas.append("companyLogo", logoImg);

    const { status, message, errors } = await myProfiles(formDatas);
  };

  return (
    <form className="default-form" onSubmit={handleSubmit}>
      <div className="uploading-outer">
        <div className="uploadButton d-flex flex-column">
          <label className="d-flex flex-start justify-content-start">
            Company Logo <span className="text-danger">*</span>
          </label>
          <input
            className="uploadButton-input"
            type="file"
            name="schoolLogo"
            accept="image/*"
            id="upload_logo"
            onChange={handleLogoChange}
          />

          <label
            className="uploadButton-button ripple-effect"
            htmlFor="upload_logo"
          >
            {logoImgPreview?.length > 0 ? (
              <>
                <img
                  src={logoImgPreview}
                  alt="Company Logo"
                  style={{ maxHeight: "80px", marginTop: "1px" }}
                />
              </>
            ) : (
              <img
                src={formData?.schoolLogo}
                alt="Company Logo"
                style={{ maxHeight: "80px", marginTop: "1px" }}
              />
            )}{" "}
          </label>
          {/* <div className="d-flex gap-5 mt-2">
            <div
              className="cursor"
              style={{ cursor: "pointer",color:"#97144d"}}
              onClick={updateProfileImage}
            >
              Update Profile
            </div>
          </div> */}
        </div>
        <div className="text ms-3">
          The Company Profile image must be in .jpg or .png format, with a
          maximum file size of 1MB and a minimum dimension of 330x300.
        </div>
      </div>

      {/* <div className="uploading-outer">
        <div className="uploadButton">
          <input
            className="uploadButton-input"
            type="file"
            name="schoolCover"
            accept="image/*"
            id="upload_cover"
            onChange={handleCoverChange}
          />
          <label
            className="uploadButton-button ripple-effect"
            htmlFor="upload_cover"
          >
            {coverImgPreview ? (
              <img
                src={coverImgPreview}
                alt="Company Cover Preview"
                style={{ maxHeight: "80px", marginTop: "1px" }}
              />
            ) : (
              <img
                src={formData.schoolCover}
                alt="Company Cover Preview"
                style={{ maxHeight: "80px", marginTop: "1px" }}
              />
            )}{" "}
          </label>
        </div>

        <div className="text ms-3">
          Max file size is 1MB, Minimum dimension: 330x300, and suitable files
          are .jpg or .png
        </div>
      </div> */}

      <div className="row">
        <div className="form-group col-lg-6 col-md-12">
          <label>
            Company Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="companyName"
            placeholder="Enter Company Name"
            value={formData.companyName}
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
          {touched.companyName && errors.companyName && (
            <span className="text-danger">{errors.companyName}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            Since <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="since"
            placeholder="eg 1998"
            value={formData.since}
            onChange={handleInputChange}
            onBlur={handleBlur}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
          {touched.since && errors.since && (
            <span className="text-danger">{errors.since}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            Employee Strength <span className="text-danger">*</span>
          </label>
          {/* <input
            type="text"
            name="teamSize"
            placeholder="eg 0-300"
            value={formData.teamSize}
            onChange={handleInputChange}
            onBlur={handleBlur}
          /> */}

          <select
            name="teamSize"
            value={formData.teamSize}
            onChange={handleInputChange}
            onBlur={handleBlur}
          >
            <option value="" disabled selected>
              Select a Employee Strength
            </option>

            <option value="1-20">1-20</option>
            <option value="21-100">21-100</option>
            <option value="101-200">101-200</option>
            <option value="201-301">201-301</option>
            <option value="500+">500+</option>

            {/* <option value="CBSE">CBSE</option>
            <option value="GOVERNMENT">Government</option>
            <option value="MATRICULATION">Matriculation</option>
            <option value="ICSE/ISC">ICSE/ISC</option>
            <option value="ACADEMY">ACADEMY</option>
            <option value="TUTION">TUTION</option> */}
          </select>
          {touched.teamSize && errors.teamSize && (
            <span className="text-danger">{errors.teamSize}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            Company Type <span className="text-danger">*</span>
          </label>
          <select
            name="type"
            value={formData.type}
            onChange={handleInputChange}
            onBlur={handleBlur}
          >
            <option value="" disabled>
              Select a Company Types
            </option>

            {CompanyTypes?.map((item, index) => {
              return (
                <>
                  <option value={item}>{item}</option>
                </>
              );
            })}
            {/* <option value="CBSE">CBSE</option>
            <option value="GOVERNMENT">Government</option>
            <option value="MATRICULATION">Matriculation</option>
            <option value="ICSE/ISC">ICSE/ISC</option>
            <option value="ACADEMY">ACADEMY</option>
            <option value="TUTION">TUTION</option> */}
          </select>
          {touched.type && errors.type && (
            <span className="text-danger">{errors.type}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            Job Title <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="jobTitle"
            value={formData.jobTitle}
            placeholder="Enter Job Title"
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
          {touched.jobTitle && errors.jobTitle && (
            <span className="text-danger">{errors.jobTitle}</span>
          )}
        </div>

        {/* <div className="form-group col-lg-6 col-md-12">
          <label>Country</label>
          <select
            name="country"
            value={formData.country}
            onChange={handleInputChange}
            onBlur={handleBlur}
          >
            <option value="" disabled>
              Select country
            </option>

            {countriesList.map((item) => (
              <option key={item.id} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
          {touched.country && errors.country && (
            <span className="text-danger">{errors.country}</span>
          )}
        </div> */}

        <div className="form-group col-lg-6 col-md-12">
          <label>
            Types Of Service <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="typesOfService"
            value={formData.typesOfService}
            placeholder="eg. IT or Non-IT"
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
          {touched.typesOfService && errors.typesOfService && (
            <span className="text-danger">{errors.typesOfService}</span>
          )}
        </div>

        {/* <div className="form-group col-lg-12 col-md-12">
          <label>Types Of Service</label>
          <input
            type="text"
            name="typesOfService"
            value={formData.typesOfService}
            placeholder="eg. IT or Non-IT"
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
          {touched.typesOfService && errors.typesOfService && (
            <span className="text-danger">{errors.typesOfService}</span>
          )}
        </div> */}

        {/* <div className="form-group col-lg-6 col-md-12">
          <label>ManPower Requirement</label>
          <input
            type="text"
            name="manPowerRequirement"
            value={formData.manPowerRequirement}
            placeholder="Manpower requirement"
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
          {touched.manPowerRequirement && errors.manPowerRequirement && (
            <span className="text-danger">{errors.manPowerRequirement}</span>
          )}
        </div> */}

        {/* <div className="form-group col-lg-6 col-md-12">
          <label>Classes</label>
          <Select
            isMulti
            name="classes"
            options={catOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            value={formData.classes}
            onChange={handleSelectChange}
            onBlur={handleSelectBlur}
          />
          {touched.classes && errors.classes && (
            <span className="text-danger">{errors.classes}</span>
          )}
        </div> */}

        {/* <div className="form-group col-lg-6 col-md-12">
          <label>Student Strength</label>
          <input
            type="text"
            name="studentStrength"
            placeholder="For ex 1500-2000"
            value={formData.studentStrength}
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
          {touched.studentStrength && errors.studentStrength && (
            <span className="text-danger">{errors.studentStrength}</span>
          )}
        </div> */}

        <div className="form-group col-lg-12 col-md-12">
          <label>
            Company Description <span className="text-danger">*</span>
          </label>
          <textarea
            name="description"
            placeholder="Enter Company Description"
            value={formData.description}
            onChange={handleInputChange}
            onBlur={handleBlur}
            style={{
              minHeight: "250px",
              width: "100%",
              resize: "none",
              overflow: "hidden",
              overflowY: "auto",
            }}
          ></textarea>
          {touched.description && errors.description && (
            <span className="text-danger">{errors.description}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12 d-flex align-items-center justify-content-center w-100">
          <button
            type="submit"
            className="theme-btn btn-style-one"
            style={!isEmpty(errors) ? { cursor: "not-allowed" } : {}}
            disabled={!isEmpty(errors)}
          >
            Save
          </button>
        </div>
      </div>
    </form>
  );
};

export default FormInfoBox;
